import { el, RedomComponent } from "redom";
import { S4yPopoverComponentOptions } from "./s4yPopoverComponentOptions";
import tippy, { Instance, Props } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import './s4yPopoverComponent.css';
import { LogHelpers } from "../../logHelper";

export class S4yPopoverComponent implements RedomComponent {
  private logHelper = new LogHelpers('S4yPopoverComponent');
  el: HTMLDivElement;
  popoverBodyContentElement: HTMLDivElement;
  closeButtonElement: HTMLButtonElement;
  private tippyInstance: Instance<Props>;

  constructor(private options?: S4yPopoverComponentOptions) {

    this.logHelper.log('Call contructor');
    this.logHelper.log(this.options);

    this.el = el('div', [
      el('div', { class: 'd-clearfix' }, [
        this.closeButtonElement = el('button', { type: 'button', class: 'd-close' }, [
          el('span', '×')
        ]),
      ]),
      this.popoverBodyContentElement = el('div')
    ]);
    this.closeButtonElement.addEventListener('click', e => {
      this.tippyInstance.hide();
    });
    this.tippyInstance = tippy(this.options.dockElement, {
      content: this.el,
      trigger: this.options.trigger,
      theme: 's4y-light',
      hideOnClick: false,
      interactive: true,
      placement: 'auto',
      maxWidth: 'none',
      popperOptions: {
        strategy: 'absolute',
        placement: 'auto',
      }
    });
  }

  onmount(): void {
  }

  onremount(): void {
  }

  onunmount(): void {
  }

  update(item: any, index: number, data: any, context?: any): void {
  }

  toggle() {
    if (this.tippyInstance.state.isShown) {
      this.tippyInstance.hide();
    } else {
      this.tippyInstance.show();
    }
  }

  public get popoverState(): {
    isEnabled: boolean;
    isVisible: boolean;
    isDestroyed: boolean;
    isMounted: boolean;
    isShown: boolean;
  } {
    return {
      ...this.tippyInstance.state
    };
  }
}